import { Cloudinary } from '@cloudinary/url-gen';
import { env } from 'lib/constants/env';

export const cloudinary = new Cloudinary({
  cloud: {
    cloudName: env.NEXT_PUBLIC_CLOUDINARY_CLOUDNAME,
  },
  url: {
    secure: true,
    analytics: false,
  },
});
